import * as Yup from "yup";
import { EMAIL_REGEX } from "./Constant";

const TOKEN_KEY = "lims_auth_token";

export const storeAuthData = ({ token }) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
};

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

export const clearAuthData = () => {
  localStorage.removeItem(TOKEN_KEY);
};

 
export const requestValidationSchema = Yup.object({
  supplier: Yup.string().required("Supplier is required."),
  item: Yup.string().trim().required("Item name is required."),
  type: Yup.string().required("Type is required."),
  customType: Yup.string().when("type", {
    is: "Custom",
    then: (schema) => schema.trim().required("Custom type is required."),
    otherwise: (schema) => schema.notRequired(),
  }),
  catalog: Yup.string().trim().required("Catalog is required."),
  manufacturer: Yup.string().trim().required("Manufacturer is required."),
  unitSize: Yup.number()
    .typeError("Unit size must be a number.")
    .moreThan(0, "Unit size must be greater than 0.")
    .required("Unit size is required."),
  numUnits: Yup.number()
    .typeError("Number of units must be a number.")
    .moreThan(0, "Number of units must be greater than 0.")
    .required("Number of units is required."),
  unitPrice: Yup.number()
    .typeError("Unit price must be a number.")
    .moreThan(0, "Unit price must be greater than 0.")
    .required("Unit price is required."),
  notes: Yup.string().trim(),
});



export const userValidationSchema = Yup.object({
  name: Yup.string().trim().required("Name is required."),
  email: Yup.string()
    .trim()
    .required("Email is required.")
    .matches(EMAIL_REGEX, "Enter a valid email address."),
  contactNumber: Yup.string().trim(),
  designation: Yup.string().trim(),
  address: Yup.string().trim(),
  admin: Yup.boolean(),
});


export const supplierValidationSchema = Yup.object({
  name: Yup.string().trim().required("Name is required."),
  email: Yup.string()
    .trim()
    .required("Email is required.")
    .matches(EMAIL_REGEX, "Enter a valid email address."),
  contactNumber: Yup.string().trim().required("Contact number is required."),
  person: Yup.string().trim(),
  address: Yup.string().trim(),
  taxId: Yup.string().trim().required("Tax ID is required."),
});

export const monthLabel = (yyyyMm) => {
    const [y, m] = yyyyMm.split('-').map(Number);
    return new Date(y, m - 1, 1).toLocaleDateString(undefined, { month: 'short' });
};

export const money = (n) =>
    new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(n || 0);